import styled from "styled-components";

const ProjectEventsTableColumn = styled.td`
    padding: 0.45rem 0.25rem !important;
    vertical-align: middle;
     max-width: 50px;
    width: ${({ width }) => width}%;
`;

export default ProjectEventsTableColumn;